import React from "react";

export const REVIEW_STATUS_OPTIONS = [
  { key: "draft", label: "Draft", color: "bg-neutral-100 text-neutral-700 border-neutral-200" },
  { key: "pending_documents", label: "Pending Documents", color: "bg-amber-50 text-amber-800 border-amber-200" },
  { key: "under_review", label: "Under Review", color: "bg-sky-50 text-sky-700 border-sky-200" },
  { key: "additional_info_required", label: "Additional Info Required", color: "bg-orange-50 text-orange-700 border-orange-200" },
  { key: "verified", label: "Verified & Approved", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { key: "live", label: "Live", color: "bg-propera-light text-propera border-propera/30" },
  { key: "rejected", label: "Rejected", color: "bg-red-50 text-red-700 border-red-200" },
  { key: "suspended", label: "Suspended", color: "bg-neutral-900 text-white border-neutral-900" },
];

const LEGACY_MAP = {
  pending: "under_review",
  approved: "live",
  changes_requested: "additional_info_required",
};

export function normaliseReviewStatus(v) {
  if (!v) return "live";
  return LEGACY_MAP[v] || v;
}

export function reviewStatus(key) {
  return REVIEW_STATUS_OPTIONS.find((o) => o.key === normaliseReviewStatus(key)) || REVIEW_STATUS_OPTIONS[0];
}

export default function ReviewStatusBadge({ status, className = "" }) {
  const s = reviewStatus(status);
  return (
    <span data-testid={`review-status-${s.key}`} className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-semibold ${s.color} ${className}`}>
      {s.label}
    </span>
  );
}
